import { render, staticRenderFns } from "./Eurohis_Counseling.vue?vue&type=template&id=65d6a244&scoped=true&lang=pug&"
import script from "./Eurohis_Counseling.vue?vue&type=script&lang=ts&"
export * from "./Eurohis_Counseling.vue?vue&type=script&lang=ts&"
import style0 from "./Eurohis_Counseling.vue?vue&type=style&index=0&id=65d6a244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d6a244",
  null
  
)

export default component.exports